import React from 'react';
import { Breadcrumb, BreadcrumbItem } from '../components/Breadcrumb';
import { Resources } from '../shared/constants/resources';
import { SxProps } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { UserFields } from '../shared/constants/users';
import { ClubFields } from '@/src/shared/constants/clubs';

type COCBreadcrumbProps = {
  sx?: SxProps;
};

const COCBreadcrumb = (props: COCBreadcrumbProps) => {
  const theme = useTheme();

  const sx = {
    root: {
      '&& li a': {
        textDecoration: 'underline',
        textUnderlineOffset: '2px',
      },
    },
    title: {
      flex: 1,
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      [theme.breakpoints.down('sm')]: {
        fontSize: '20px',
      },
    },
  };

  return (
    <Breadcrumb sx={[sx.root, ...(Array.isArray(props.sx) ? props.sx : [props.sx])]}>
      <BreadcrumbItem
        name={Resources.ClubProfile}
        label="Club Profile"
        to={`/${Resources.ClubProfile}`}
      >
        <BreadcrumbItem
          name="edit"
          label={({ record }) => `Edit ${record?.[UserFields.Username] || ''}`}
        />
        <BreadcrumbItem
          name="show"
          label={({ record }) => `${record?.[ClubFields.Name] || ''}`}
        />
        <BreadcrumbItem
          name="create"
          label="Create Club"
          to={`/${Resources.ClubProfile}/create`}
        />
      </BreadcrumbItem>
      <BreadcrumbItem
        name={Resources.Groups}
        label="Team Management"
        to={`/${Resources.Groups}`}
      >
        <BreadcrumbItem name="create" label="Invite" />
      </BreadcrumbItem>
      <BreadcrumbItem
        name={Resources.Academy}
        label="Swish Academy"
        to={`/${Resources.Academy}`}
      ></BreadcrumbItem>
    </Breadcrumb>
  );
};

export default COCBreadcrumb;
